import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { VendorCard } from "@/components/marketplace/VendorCard";
import { SectionHeader } from "@/components/marketplace/SectionHeader";
import { LoadingState } from "@/components/common/States";

export default function Vendors() {
  const [vendors, setVendors] = useState(null);
  useEffect(() => {
    api.get("/vendors").then((r) => setVendors(r.data));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <SectionHeader
        eyebrow="Marketplace"
        title="Our Vendors"
        subtitle="Verified artisans, manufacturers and sellers of spiritual & traditional products across India."
      />
      {vendors === null ? (
        <LoadingState />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="vendors-grid">
          {vendors.map((v) => <VendorCard key={v.slug} vendor={v} />)}
        </div>
      )}
    </div>
  );
}
